import React, { Component } from 'react'
import { Provider, observer } from 'mobx-react'
import { Button } from 'hljd'
import styles from './index.module.less'
import Store from './store'
import { HeaderView } from '@merchant-backend/common-components'
import ReviewStatus from '@components/Hotel/Common/ReviewStatus'
import Item from './Item'
import CourseGuide from '@components/LocalMerchant/Common/CourseGuide'
import { isNewOpen } from '@util'

// @AuthTo({ isAuthed: isUltimate, productId: PRODUCT_UNIQUE_INFO })
@observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()

    // if (isUltimate()) {
    //   this.store.editable = true
    // }
    const { id } = props.location.query
    if (id) {
      this.store.getTags()
    }
  }

  UNSAFE_componentWillMount() {
    this.store.getUniqueInfo(true)
  }

  render() {
    const {
      overviewStatus,
      reason,
      loading
      // editable,
      // openStatus,
      // changeOpenStatus
    } = this.store
    return (
      <Provider uniqueInfoStore={this.store}>
        <HeaderView title="特色信息">
          {isNewOpen() && <CourseGuide taskId="7" />}
          {/* {!openStatus && <NotOpen onOpen={changeOpenStatus} />}
          {openStatus && ( */}
          <>
            <ReviewStatus status={overviewStatus} reason={reason} />
            <Item index={0} />
            <Item index={1} />
          </>
          {/* )} */}

          {/* {openStatus && ( */}
          <div className={styles.saveWrapper}>
            <Button
              className={styles.save}
              type="primary"
              onClick={this.store.save}
              loading={loading}
            >
              保存
            </Button>
          </div>
          {/* )} */}
        </HeaderView>
      </Provider>
    )
  }
}
